import React, { useState, useEffect } from "react";
import { api } from "./api";
import { Label } from "../components/ui/label";

/**
 * Complete and accurate dataset of all 28 Indian States and 8 Union Territories
 * with their respective official administrative districts.
 */
export const INDIAN_STATES_AND_DISTRICTS = {
  "Andhra Pradesh": [
    "Alluri Sitharama Raju", "Anakapalli", "Ananthapuramu", "Annamayya", "Bapatla", "Chittoor",
    "Dr. B.R. Ambedkar Konaseema", "East Godavari", "Eluru", "Guntur", "Kakinada", "Krishna",
    "Kurnool", "Nandyal", "NTR (Vijayawada)", "Palnadu", "Parvathipuram Manyam", "Prakasam",
    "Sri Potti Sriramulu Nellore", "Sri Sathya Sai", "Srikakulam", "Tirupati", "Visakhapatnam",
    "Vizianagaram", "West Godavari", "YSR Kadapa"
  ],
  "Arunachal Pradesh": [
    "Anjaw", "Changlang", "Dibang Valley", "East Kameng", "East Siang", "Kamle", "Kra Daadi",
    "Kurung Kumey", "Lepa Rada", "Lohit", "Longding", "Lower Dibang Valley", "Lower Siang",
    "Lower Subansiri", "Namsai", "Pakke Kessang", "Papum Pare", "Shi Yomi", "Siang", "Tawang",
    "Tirap", "Upper Siang", "Upper Subansiri", "West Kameng", "West Siang", "Itanagar Capital Complex"
  ],
  "Assam": [
    "Baksa", "Barpeta", "Biswanath", "Bongaigaon", "Cachar", "Charaideo", "Chirang", "Darrang",
    "Dhemaji", "Dhubri", "Dibrugarh", "Dima Hasao", "Goalpara", "Golaghat", "Hailakandi",
    "Hojai", "Jorhat", "Kamrup Metropolitan (Guwahati)", "Kamrup Rural", "Karbi Anglong", "Karimganj",
    "Kokrajhar", "Lakhimpur", "Majuli", "Morigaon", "Nagaon", "Nalbari", "Sivasagar", "Sonitpur (Tezpur)",
    "South Salmara-Mankachar", "Tamulpur", "Tinsukia", "Udalguri", "West Karbi Anglong"
  ],
  "Bihar": [
    "Araria", "Arwal", "Aurangabad", "Banka", "Begusarai", "Bhagalpur", "Bhojpur (Arrah)", "Buxar",
    "Darbhanga", "East Champaran (Motihari)", "Gaya", "Gopalganj", "Jamui", "Jehanabad", "Kaimur (Bhabua)",
    "Katihar", "Khagaria", "Kishanganj", "Lakhisarai", "Madhepura", "Madhubani", "Munger", "Muzaffarpur",
    "Nalanda (Bihar Sharif)", "Nawada", "Patna", "Purnia", "Rohtas (Sasaram)", "Saharsa", "Samastipur",
    "Saran (Chhapra)", "Sheikhpura", "Sheohar", "Sitamarhi", "Siwan", "Supaul", "Vaishali (Hajipur)",
    "West Champaran (Bettiah)"
  ],
  "Chhattisgarh": [
    "Balod", "Baloda Bazar-Bhatapara", "Balrampur-Ramanujganj", "Bastar (Jagdalpur)", "Bemetara",
    "Bijapur", "Bilaspur", "Dakshin Bastar Dantewada", "Dhamtari", "Durg (Bhilai)", "Gariaband",
    "Gaurela-Pendra-Marwahi", "Janjgir-Champa", "Jashpur", "Kabirdham (Kawardha)", "Kanker (North Bastar)",
    "Khairagarh-Chhuikhadan-Gandai", "Kondagaon", "Korba", "Koriya", "Mahasamund", "Manendragarh-Chirmiri-Bharatpur",
    "Mohla-Manpur-Ambagarh Chowki", "Mungeli", "Narayanpur", "Raigarh", "Raipur", "Rajnandgaon",
    "Sarangarh-Bilaigarh", "Shakti", "Sukma", "Surajpur", "Surguja (Ambikapur)"
  ],
  "Goa": [
    "North Goa (Panaji, Mapusa, Bicholim, Ponda)",
    "South Goa (Margao, Vasco da Gama, Quepem, Canacona)"
  ],
  "Gujarat": [
    "Ahmedabad", "Amreli", "Anand", "Aravalli (Modasa)", "Banaskantha (Palanpur)", "Bharuch",
    "Bhavnagar", "Botad", "Chhota Udaipur", "Dahod", "Dang (Ahwa)", "Devbhumi Dwarka (Khambhalia)",
    "Gandhinagar", "Gir Somnath (Veraval)", "Jamnagar", "Junagadh", "Kheda (Nadiad)", "Kutch (Bhuj)",
    "Mahisagar (Lunawada)", "Mehsana", "Morbi", "Narmada (Rajpipla)", "Navsari", "Panchmahal (Godhra)",
    "Patan", "Porbandar", "Rajkot", "Sabarkantha (Himmatnagar)", "Surat", "Surendranagar", "Tapi (Vyara)",
    "Vadodara", "Valsad (Vapi)"
  ],
  "Haryana": [
    "Ambala", "Bhiwani", "Charkhi Dadri", "Faridabad", "Fatehabad", "Gurugram (Gurgaon)", "Hisar",
    "Jhajjar", "Jind", "Kaithal", "Karnal", "Kurukshetra", "Mahendragarh (Narnaul)", "Nuh (Mewat)",
    "Palwal", "Panchkula", "Panipat", "Rewari", "Rohtak", "Sirsa", "Sonipat", "Yamunanagar"
  ],
  "Himachal Pradesh": [
    "Bilaspur", "Chamba", "Hamirpur", "Kangra (Dharamshala)", "Kinnaur (Reckong Peo)", "Kullu",
    "Lahaul and Spiti (Keylong)", "Mandi", "Shimla", "Sirmaur (Nahan)", "Solan (Baddi)", "Una"
  ],
  "Jharkhand": [
    "Bokaro", "Chatra", "Deoghar", "Dhanbad", "Dumka", "East Singhbhum (Jamshedpur)", "Garhwa",
    "Giridih", "Godda", "Gumla", "Hazaribagh", "Jamtara", "Khunti", "Koderma", "Latehar",
    "Lohardaga", "Pakur", "Palamu (Medininagar)", "Ramgarh", "Ranchi", "Sahibganj", "Saraikela-Kharsawan",
    "Simdega", "West Singhbhum (Chaibasa)"
  ],
  "Karnataka": [
    "Bagalkote", "Ballari (Bellary)", "Belagavi (Belgaum)", "Bengaluru Rural", "Bengaluru Urban",
    "Bidar", "Chamarajanagara", "Chikkaballapura", "Chikkamagaluru", "Chitradurga", "Dakshina Kannada (Mangaluru)",
    "Davanagere", "Dharwad (Hubballi)", "Gadag", "Hassan", "Haveri", "Kalaburagi (Gulbarga)", "Kodagu (Madikeri)",
    "Kolar", "Koppal", "Mandya", "Mysuru (Mysore)", "Raichur", "Ramanagara", "Shivamogga (Shimoga)",
    "Tumakuru (Tumkur)", "Udupi", "Uttara Kannada (Karwar)", "Vijayanagara (Hosapete)", "Vijayapura (Bijapur)", "Yadgir"
  ],
  "Kerala": [
    "Alappuzha", "Ernakulam (Kochi)", "Idukki (Painavu)", "Kannur", "Kasaragod", "Kollam",
    "Kottayam", "Kozhikode (Calicut)", "Malappuram", "Palakkad", "Pathanamthitta", "Thiruvananthapuram (Trivandrum)",
    "Thrissur", "Wayanad (Kalpetta)"
  ],
  "Madhya Pradesh": [
    "Agar Malwa", "Alirajpur", "Anuppur", "Ashoknagar", "Balaghat", "Barwani", "Betul", "Bhind",
    "Bhopal", "Burhanpur", "Chhatarpur", "Chhindwara", "Damoh", "Datia", "Dewas", "Dhar", "Dindori",
    "Guna", "Gwalior", "Harda", "Hoshangabad (Narmadapuram)", "Indore", "Jabalpur", "Jhabua",
    "Katni", "Khandwa (East Nimar)", "Khargone (West Nimar)", "Maihar", "Mandla", "Mandsaur",
    "Mauganj", "Morena", "Narsinghpur", "Neemuch", "Niwari", "Panna", "Pandhurna", "Raisen",
    "Rajgarh", "Ratlam", "Rewa", "Sagar", "Satna", "Sehore", "Seoni", "Shahdol", "Shajapur",
    "Sheopur", "Shivpuri", "Sidhi", "Singrauli", "Tikamgarh", "Ujjain", "Umaria", "Vidisha"
  ],
  "Maharashtra": [
    "Ahmednagar (Ahilyanagar)", "Akola", "Amravati", "Aurangabad (Chhatrapati Sambhajinagar)", "Beed",
    "Bhandara", "Buldhana", "Chandrapur", "Dhule", "Gadchiroli", "Gondia", "Hingoli", "Jalgaon",
    "Jalna", "Kolhapur", "Latur", "Mumbai City (Zaveri Bazaar, Fort, Colaba, Dadar)", "Mumbai Suburban (Bandra, Andheri, Borivali, Ghatkopar)",
    "Nagpur", "Nanded", "Nandurbar", "Nashik", "Osmanabad (Dharashiv)", "Palghar", "Parbhani",
    "Pune", "Raigad (Alibag, Navi Mumbai Panvel)", "Ratnagiri", "Sangli", "Satara", "Sindhudurg",
    "Solapur", "Thane (Kalyan, Dombivli, Mira-Bhayandar)", "Wardha", "Washim", "Yavatmal"
  ],
  "Manipur": [
    "Bishnupur", "Chandel", "Churachandpur", "Imphal East", "Imphal West", "Jiribam", "Kakching",
    "Kamjong", "Kangpokpi", "Noney", "Pherzawl", "Senapati", "Tamenglong", "Tengnoupal", "Thoubal", "Ukhrul"
  ],
  "Meghalaya": [
    "Eastern West Khasi Hills", "East Garo Hills (Williamnagar)", "East Jaintia Hills (Khliehriat)",
    "East Khasi Hills (Shillong)", "North Garo Hills (Resubelpara)", "Ri-Bhoi (Nongpoh)", "South Garo Hills (Baghmara)",
    "South West Garo Hills (Ampati)", "South West Khasi Hills (Mawkyrwat)", "West Garo Hills (Tura)",
    "West Jaintia Hills (Jowai)", "West Khasi Hills (Nongstoin)"
  ],
  "Mizoram": [
    "Aizawl", "Champhai", "Hnahthial", "Khawzawl", "Kolasib", "Lawngtlai", "Lunglei",
    "Mamit", "Saitual", "Serchhip", "Siaha"
  ],
  "Nagaland": [
    "Chumoukedima", "Dimapur", "Kiphire", "Kohima", "Longleng", "Mokokchung", "Mon",
    "Niuland", "Noklak", "Peren", "Phek", "Shamator", "Tseminyu", "Tuensang", "Wokha", "Zunheboto"
  ],
  "Odisha": [
    "Angul", "Balangir", "Balasore (Baleswar)", "Bargarh", "Bhadrak", "Boudh", "Cuttack",
    "Deogarh", "Dhenkanal", "Gajapati (Paralakhemundi)", "Ganjam (Berhampur)", "Jagatsinghpur",
    "Jajpur", "Jharsuguda", "Kalahandi (Bhawanipatna)", "Kandhamal (Phulbani)", "Kendrapara",
    "Kendujhar (Keonjhar)", "Khordha (Bhubaneswar)", "Koraput", "Malkangiri", "Mayurbhanj (Baripada)",
    "Nabarangpur", "Nayagarh", "Nuapada", "Puri", "Rayagada", "Sambalpur", "Subarnapur (Sonepur)", "Sundargarh (Rourkela)"
  ],
  "Punjab": [
    "Amritsar", "Barnala", "Bathinda", "Faridkot", "Fatehgarh Sahib", "Fazilka", "Ferozepur",
    "Gurdaspur", "Hoshiarpur", "Jalandhar", "Kapurthala", "Ludhiana", "Malerkotla", "Mansa",
    "Moga", "Muktsar", "Pathankot", "Patiala", "Rupnagar (Ropar)", "Sahibzada Ajit Singh Nagar (Mohali)",
    "Sangrur", "Shahid Bhagat Singh Nagar (Nawanshahr)", "Tarn Taran"
  ],
  "Rajasthan": [
    "Ajmer", "Alwar", "Anupgarh", "Balotra", "Banswara", "Baran", "Barmer", "Beawar", "Bharatpur",
    "Bhilwara", "Bikaner", "Bundi", "Chittorgarh", "Churu", "Dausa", "Deeg", "Dholpur", "Didwana-Kuchaman",
    "Dudu", "Dungarpur", "Ganganagar (Sri Ganganagar)", "Gangapur City", "Hanumangarh", "Jaipur City",
    "Jaipur Rural", "Jaisalmer", "Jalore", "Jhalawar", "Jhunjhunu", "Jodhpur City", "Jodhpur Rural",
    "Karauli", "Kekri", "Khairthal-Tijara", "Kota", "Kotputli-Behror", "Nagaur", "Neem Ka Thana",
    "Pali", "Phalodi", "Pratapgarh", "Rajsamand", "Salumbar", "Sanchore", "Sawai Madhopur", "Shahpura",
    "Sikar", "Sirohi", "Tonk", "Udaipur"
  ],
  "Sikkim": [
    "Gangtok (East Sikkim)", "Gyalshing (West Sikkim)", "Mangan (North Sikkim)", "Namchi (South Sikkim)",
    "Pakyong", "Soreng"
  ],
  "Tamil Nadu": [
    "Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri", "Dindigul",
    "Erode", "Kallakurichi", "Kanchipuram", "Kanyakumari (Nagercoil)", "Karur", "Krishnagiri",
    "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal", "Nilgiris (Ooty)", "Perambalur",
    "Pudukkottai", "Ramanathapuram", "Ranipet", "Salem", "Sivaganga", "Tenkasi", "Thanjavur",
    "Theni", "Thoothukudi (Tuticorin)", "Tiruchirappalli (Trichy)", "Tirunelveli", "Tirupathur",
    "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Vellore", "Viluppuram", "Virudhunagar"
  ],
  "Telangana": [
    "Adilabad", "Bhadradri Kothagudem", "Hanumakonda", "Hyderabad", "Jagtial", "Jangaon",
    "Jayashankar Bhupalpally", "Jogulamba Gadwal", "Kamareddy", "Karimnagar", "Khammam",
    "Kumuram Bheem Asifabad", "Mahabubabad", "Mahbubnagar", "Mancherial", "Medak",
    "Medchal-Malkajgiri", "Mulugu", "Nagarkurnool", "Nalgonda", "Narayanpet", "Nirmal",
    "Nizamabad", "Peddapalli", "Rajanna Sircilla", "Ranga Reddy", "Sangareddy", "Siddipet",
    "Suryapet", "Vikarabad", "Wanaparthy", "Warangal", "Yadadri Bhuvanagiri"
  ],
  "Tripura": [
    "Dhalai (Ambassa)", "Gomati (Udaipur)", "Khowai", "North Tripura (Dharmanagar)", "Sepahijala (Bishramganj)",
    "South Tripura (Belonia)", "Unakoti (Kailashahar)", "West Tripura (Agartala)"
  ],
  "Uttar Pradesh": [
    "Agra", "Aligarh", "Ambedkar Nagar", "Amethi", "Amroha", "Auraiya", "Ayodhya (Faizabad)", "Azamgarh",
    "Baghpat", "Bahraich", "Ballia", "Balrampur", "Banda", "Barabanki", "Bareilly", "Basti", "Bhadohi",
    "Bijnor", "Budaun", "Bulandshahr", "Chandauli", "Chitrakoot", "Deoria", "Etah", "Etawah", "Farrukhabad",
    "Fatehpur", "Firozabad", "Gautam Buddha Nagar (Noida, Greater Noida)", "Ghaziabad", "Ghazipur", "Gonda",
    "Gorakhpur", "Hamirpur", "Hapur", "Hardoi", "Hathras", "Jalaun (Orai)", "Jaunpur", "Jhansi", "Kannauj",
    "Kanpur Dehat", "Kanpur Nagar", "Kasganj", "Kaushambi", "Kheri (Lakhimpur Kheri)", "Kushinagar",
    "Lalitpur", "Lucknow", "Maharajganj", "Mahoba", "Mainpuri", "Mathura", "Mau", "Meerut", "Mirzapur",
    "Moradabad", "Muzaffarnagar", "Pilibhit", "Pratapgarh", "Prayagraj (Allahabad)", "Raebareli", "Rampur",
    "Saharanpur", "Sambhal", "Sant Kabir Nagar (Khalilabad)", "Shahjahanpur", "Shamli", "Shravasti",
    "Siddharthnagar", "Sitapur", "Sonbhadra", "Sultanpur", "Unnao", "Varanasi (Kashi)"
  ],
  "Uttarakhand": [
    "Almora", "Bageshwar", "Chamoli (Gopeshwar)", "Champawat", "Dehradun (Rishikesh)", "Haridwar (Roorkee)",
    "Nainital (Haldwani)", "Pauri Garhwal", "Pithoragarh", "Rudraprayag", "Tehri Garhwal", "Udham Singh Nagar (Rudrapur, Kashipur)",
    "Uttarkashi"
  ],
  "West Bengal": [
    "Alipurduar", "Bankura", "Birbhum (Suri)", "Cooch Behar", "Dakshin Dinajpur (Balurghat)", "Darjeeling",
    "Hooghly (Chinsurah)", "Howrah", "Jalpaiguri", "Jhargram", "Kalimpong", "Kolkata (Burrabazar, Bowbazar)",
    "Malda", "Murshidabad (Baharampur)", "Nadia (Krishnanagar)", "North 24 Parganas (Barasat)",
    "Paschim Bardhaman (Asansol, Durgapur)", "Paschim Medinipur (Midnapore)", "Purba Bardhaman (Bardhaman)",
    "Purba Medinipur (Tamluk)", "Purulia", "South 24 Parganas (Alipore)", "Uttar Dinajpur (Raiganj)"
  ],

  // 8 Union Territories
  "Andaman and Nicobar Islands": [
    "Nicobar (Car Nicobar)", "North and Middle Andaman (Mayabunder)", "South Andaman (Port Blair)"
  ],
  "Chandigarh": [
    "Chandigarh (Sector 1 to 60)", "Manimajra", "Industrial Area Phase 1 & 2"
  ],
  "Dadra and Nagar Haveli and Daman and Diu": [
    "Dadra and Nagar Haveli (Silvassa)", "Daman", "Diu"
  ],
  "Delhi (NCT)": [
    "Central Delhi (Chandni Chowk, Daryaganj)", "East Delhi (Preet Vihar, Laxmi Nagar)",
    "New Delhi (Connaught Place, Chanakyapuri)", "North Delhi (Sadar Bazar, Civil Lines)",
    "North East Delhi (Shahdara, Seelampur)", "North West Delhi (Rohini, Pitampura)",
    "Shahdara (Vivek Vihar, Dilshad Garden)", "South Delhi (Hauz Khas, Saket, Greater Kailash)",
    "South East Delhi (Lajpat Nagar, Kalkaji, Defence Colony)", "South West Delhi (Dwarka, Vasant Kunj)",
    "West Delhi (Karol Bagh, Rajouri Garden, Janakpuri, Patel Nagar)"
  ],
  "Jammu and Kashmir": [
    "Anantnag", "Bandipora", "Baramulla", "Budgam", "Doda", "Ganderbal", "Jammu", "Kathua",
    "Kishtwar", "Kulgam", "Kupwara", "Poonch", "Pulwama", "Rajouri", "Ramban", "Reasi (Katra)",
    "Samba", "Shopian", "Srinagar", "Udhampur"
  ],
  "Ladakh": [
    "Leh", "Kargil"
  ],
  "Lakshadweep": [
    "Kavaratti", "Agatti", "Amini", "Andrott", "Bitra", "Chetlat", "Kadmat", "Kalpeni", "Kiltan", "Minicoy"
  ],
  "Puducherry": [
    "Puducherry", "Karaikal", "Mahe", "Yanam"
  ]
};

// Aliases for compatibility
export const INDIAN_STATES_AND_CITIES = INDIAN_STATES_AND_DISTRICTS;
export const INDIAN_STATES = Object.keys(INDIAN_STATES_AND_DISTRICTS);

/**
 * Helper to fetch sorted districts for any given state
 */
export function getDistrictsForState(state) {
  if (!state || !INDIAN_STATES_AND_DISTRICTS[state]) {
    return ["Other"];
  }
  return [...INDIAN_STATES_AND_DISTRICTS[state], "Other"];
}

export const getCitiesForState = getDistrictsForState;

let cachedServingArea = null;
let servingAreaPromise = null;

export async function fetchServiceableAreas() {
  if (cachedServingArea) return cachedServingArea;
  if (!servingAreaPromise) {
    servingAreaPromise = api
      .get("/serviceable-areas/public")
      .then((res) => {
        cachedServingArea = res.data;
        return res.data;
      })
      .catch((err) => {
        console.warn("[indiaData] Failed to load serviceable areas:", err);
        return null;
      });
  }
  return servingAreaPromise;
}

/**
 * Reusable Indian State and District / City Dropdown Component
 * Filtered to only display active/serviceable states and cities.
 */
export function StateCitySelector({
  state = "Maharashtra",
  city = "",
  onStateChange,
  onCityChange,
  stateLabel = "State *",
  cityLabel = "District / City *",
  testIdPrefix = "location",
  className = "",
  disabled = false,
  required = true,
  isServiceable = true,
  enabledStates = null,
  disabledDistricts = null,
  servingConfig = null,
  activeOnly = true,
}) {
  const [liveConfig, setLiveConfig] = useState(servingConfig || cachedServingArea);

  useEffect(() => {
    if (servingConfig) {
      setLiveConfig(servingConfig);
      return;
    }
    fetchServiceableAreas().then((data) => {
      if (data) setLiveConfig(data);
    });
  }, [servingConfig]);

  // Determine active states list
  const activeStatesList = enabledStates || liveConfig?.enabled_states || null;
  const availableStates = (activeOnly && Array.isArray(activeStatesList) && activeStatesList.length > 0)
    ? INDIAN_STATES.filter((s) => activeStatesList.includes(s))
    : INDIAN_STATES;

  const currentState = (state && availableStates.includes(state))
    ? state
    : (availableStates[0] || "Maharashtra");

  // Sync state if initial value was empty or unserviceable
  useEffect(() => {
    if (currentState && currentState !== state && typeof onStateChange === "function") {
      onStateChange(currentState);
    }
  }, [currentState, state, onStateChange]);

  // Determine blocked districts for current state
  const allDistricts = getDistrictsForState(currentState);
  const blockedList = Array.isArray(disabledDistricts)
    ? disabledDistricts
    : (disabledDistricts && disabledDistricts[currentState])
    || (liveConfig?.disabled_districts && liveConfig.disabled_districts[currentState])
    || [];

  const availableDistricts = activeOnly
    ? allDistricts.filter((d) => !blockedList.includes(d))
    : allDistricts;

  const currentDistricts = availableDistricts.length > 0 ? availableDistricts : allDistricts;
  const currentCity = (city && currentDistricts.includes(city))
    ? city
    : (currentDistricts[0] || "");

  // Sync city if initial value was empty or unserviceable
  useEffect(() => {
    if (currentCity && currentCity !== city && typeof onCityChange === "function") {
      onCityChange(currentCity);
    }
  }, [currentCity, city, onCityChange]);

  const handleStateSelect = (newState) => {
    if (typeof onStateChange === "function") {
      onStateChange(newState);
    }
    const newDistricts = getDistrictsForState(newState);
    const newBlocked = Array.isArray(disabledDistricts)
      ? disabledDistricts
      : (disabledDistricts && disabledDistricts[newState])
      || (liveConfig?.disabled_districts && liveConfig.disabled_districts[newState])
      || [];
    const validDistricts = activeOnly
      ? newDistricts.filter((d) => !newBlocked.includes(d))
      : newDistricts;
    const finalDistricts = validDistricts.length > 0 ? validDistricts : newDistricts;
    if (typeof onCityChange === "function") {
      onCityChange(finalDistricts[0] || "");
    }
  };

  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 gap-2.5 sm:gap-3 w-full min-w-0 ${className}`}>
      <div className="space-y-1.5 w-full min-w-0">
        {stateLabel && (
          <div className="flex items-center justify-between gap-1">
            <Label className="text-stone-600 text-xs font-semibold truncate">{stateLabel}</Label>
            {!isServiceable && (
              <span className="text-[10px] text-amber-600 font-bold bg-amber-50 px-1.5 py-0.5 rounded border border-amber-200 shrink-0">
                Limited Delivery
              </span>
            )}
          </div>
        )}
        <select
          data-testid={`${testIdPrefix}-state-select`}
          value={currentState}
          onChange={(e) => handleStateSelect(e.target.value)}
          disabled={disabled}
          required={required}
          className="w-full max-w-full min-w-0 box-border h-9 sm:h-10 px-2.5 sm:px-3 rounded-lg bg-stone-50 border border-stone-200 text-xs sm:text-sm text-stone-900 focus:outline-none focus:border-[#0a2140] transition-colors truncate"
        >
          {availableStates.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>

      <div className="space-y-1.5 w-full min-w-0">
        {cityLabel && <Label className="text-stone-600 text-xs font-semibold truncate">{cityLabel}</Label>}
        <select
          data-testid={`${testIdPrefix}-city-select`}
          value={currentCity}
          onChange={(e) => onCityChange(e.target.value)}
          disabled={disabled}
          required={required}
          className="w-full max-w-full min-w-0 box-border h-9 sm:h-10 px-2.5 sm:px-3 rounded-lg bg-stone-50 border border-stone-200 text-xs sm:text-sm text-stone-900 focus:outline-none focus:border-[#0a2140] transition-colors truncate"
        >
          {currentDistricts.map((d) => (
            <option key={d} value={d}>
              {d}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
